<template>
	<div>
		<div class="container-fluid">
			<div class="row">
				<div class="col-12 col-xl-10">
					<!--<p class="mb-2">
						<router-link tag="a" :to="{ name : 'admin.organizations.index'}" class="button icon-button">
							<img src="../../../assets/images/icons/solid/angle-left-white.svg" width="8" class="mr-1" />
							<span>Back</span>
						</router-link>
					</p>-->
					<div class="row align-items-center justify-content-between">
						<div class="col-12 col-lg-12">
							<h3 class="mt-0 mb-4 pb-2 pt-2" v-if="organization != null">{{ organization.name }} - Import file</h3>
						</div><!--col-->
					</div><!--row-->

					<template v-if="import_ != null">
						<!-- column mapping -->
						<template v-if="import_.status == 'mapping'">
							<div class="row">
								<div class="col-12">
									<div class="mt-1 mb-2">
										Column mapping 

										<button type="button" class="button float-right" @click="saveFields(true)"> Save fields and preview import</button>
										<button type="button" class="button float-right mr-2" @click="saveFields(false)">Save fields</button>

										<router-link :to="{ name : 'admin.organizations.detail', params : { agency_id : id } }" tag="button" class="button float-right mr-2">
											Back
										</router-link>										
									</div>
								</div>

								<div class="table-responsive">
									<table class="table">
										<thead>
											<th>Excel Column</th>
											<th>Sample Data</th>
											<th>System Field</th>
											<th>Value (default)</th>
										</thead>
										<tbody>
											<tr v-for="column in import_.columns">
												<td width=30%>{{ column.excel_column }}</td>
												<td width=25%>{{ sample_data[column.excel_column] }}</td>
												<td width=25%>
													<v-select class="mb-2 clearable" 
															:searchable="true"  track-by="value" label="label"
														v-model="column.label" :options="fields" :clearable="true">
													</v-select>	
												</td>
												<td width=20%>
													<template v-for="field in fields" v-if="f_format_object_column(column.nevvon_column) == field.value || f_format_object_column(column.label) == field.value ">
														<p v-if="field.type=='date'">
															<v-select placeholder="Choose date format" class="mb-2"  
																track-by="field.value" 
																v-model="column.format" :options="date_formats">
															</v-select>
														</p>
														<p v-else> {{field.default}} </p>
													</template>
												</td>
											</tr>
										</tbody>
									</table>
								</div>

								<!-- alert for preview import -->
								<b-modal id="alert-preview" v-model="open_preview" title="Preview import" size="lg" @ok="saveFields(true)">
									<p>
										You are about to preview the import for the excel file you upload. This may take a while if the excel is too big. 
									</p>	

									<p>Current status of column mapping</p>
									<div class="table-responsive">
										<table class="table">
											<thead>
												<th>Column</th>
												<th>Field</th>
												<th>Value (default)</th>
											</thead>
											<tbody>
												<tr v-for="column in import_.columns">
													<td>{{ column.excel_column }}</td>
													<td>
														{{ column.nevvon_column | format_object_column}}						
													</td>
													<td>
														<template v-for="field in fields" v-if="f_format_object_column(column.nevvon_column) == field.value">
																{{field.default}}
														</template>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</b-modal>
							</div>
						</template>

						<!-- loading preview and preview -->
						<template v-if="import_.show_preview">
							<div class="row">
								<div class="col-12">

									<p>({{ import_.status }}) Running: {{ import_.running_jobs }}, in queue: {{ import_.pending_jobs }} | 
										 <router-link :to="{ name : 'admin.organizations.detail', params : { agency_id : id } }" tag="button" class="button">
											Back
										</router-link>
										
										<button type="button" class="button" @click="refreshPreview()" :disabled="refreshing">Refresh</button>
										<button type="button" class="button" v-if="import_.status == 'preview'" v-b-modal.alert-import>Import</button> 
										<button type="button" class="button" v-if="previews.data && previews.data.length>0 " @click="exportCSV()" v-b-modal.alert-export>Export CSV</button> 

										
									</p>

									<p v-if="import_.status == 'loadin_preview' || import_.status == 'waiting_queue' || import_.status == 'importing'">
										Proccessing the excel file might take a minute or more... Please refresh in a few moments.
									</p>

									<p> Filter by status: <span class="text-info" @click="filterPreviewByStatus('all')" :class="{ 'bold' : previews.filter_status == 'all' && previews.active_filter == 'status' }">All: {{ import_.count_status.all }}</span> | 
										<span class="text-success" @click="filterPreviewByStatus('success')" :class="{ 'bold' : previews.filter_status == 'success' && previews.active_filter == 'status'}">Success: {{ import_.count_status.success }}</span> | 
										<span class="text-danger" @click="filterPreviewByStatus('error')" :class="{ 'bold' : previews.filter_status == 'error' && previews.active_filter == 'status'}">Error: {{ import_.count_status.error }} </span> | 
										<span class="text-danger" @click="filterPreviewByStatus('server_error')" :class="{ 'bold' : previews.filter_status == 'server_error' && previews.active_filter == 'status'}">Server error: {{ import_.count_status.server_error }}</span></p>
									</p>
									<p>
										Filter by import status: 
										<span class="text-info" @click="filterPreviewByImportStatus('all')" :class="{ 'bold' : previews.filter_import_status == 'all' && previews.active_filter == 'import' }">All: {{ import_.count_status.all }}</span> | 
										<span class="text-success" @click="filterPreviewByImportStatus('imported')" :class="{ 'bold' : previews.filter_import_status == 'imported' && previews.active_filter == 'import'}">Success: {{ import_.count_status.import_success }}</span> |
										<span class="text-primary" @click="filterPreviewByImportStatus('pending')" :class="{ 'bold' : previews.filter_import_status == 'pending' && previews.active_filter == 'import'}">Pending: {{ import_.count_status.import_pending }}</span> |
										<span class="text-danger" @click="filterPreviewByImportStatus('error')" :class="{ 'bold' : previews.filter_import_status == 'error' && previews.active_filter == 'import'}">Error: {{ import_.count_status.import_error }}</span> |
										<span class="text-danger" @click="filterPreviewByImportStatus('server_error')" :class="{ 'bold' : previews.filter_import_status == 'server_error' && previews.active_filter == 'import'}">Server error: {{ import_.count_status.import_server_error }}</span>
									</p>
									<p>
										<span class="" :class="{ 'bold' : previews.view == 'simple' }" @click="previews.view = 'simple'">Simple</span> | 
										<span class="" :class="{ 'bold' : previews.view == 'complete' }" @click="previews.view = 'complete'">Complete</span>
									</p>
									<div class="table-responsive">
										<table class="table" :class="{ 'table-loading' : refreshing }">
											<thead>
												<th>Status</th>
												<th>Import status</th>
												<th>Row</th>
												<th>First name</th>
												<th>Last name</th>
												<th>Program starting date</th>
												<th>Onboard date</th>
												<th>Duration method</th>
												<th>Country code</th>
												<th>Telephone number</th>
												<th v-if="previews.view == 'complete'">Coordinator</th>
												<th v-if="previews.view == 'complete'">LHCSA manager</th>
												<th v-if="previews.view == 'complete'">Manager approving the HHA score</th>
												<th v-if="previews.view == 'complete'">Supporting RN</th>
												<th v-if="previews.view == 'complete'">Employee number</th>
												<th v-if="previews.view == 'complete'">SSN</th>
												<!-- <th v-if="previews.view == 'complete'">Birthday</th> -->
												<th v-if="previews.view == 'complete'">Preferred language</th>
												<th v-if="previews.view == 'complete'">HHA registry number</th>
												<th v-if="previews.view == 'complete'">Discipline</th>
												<th v-if="previews.view == 'complete'">Location</th>
											</thead>
											<tbody>
												<tr v-for="row in previews.data">
													<td>
														<span :id="'tooltip-' + row.i" :class="'text-' + row.status.toLowerCase()">{{ row.status }}</span>

														<b-tooltip :target="'tooltip-' + row.i">
															<ul class="error-tooltip">
																<li v-for="message in row.message">{{ message }}</li>
															</ul>

														</b-tooltip>

													</td>
													<td>
														{{ row.import_status }}
													</td>
													<td>{{ row.i }}</td>
													<td>{{ row.first_name }}</td>
													<td>{{ row.last_name }}</td>
													<td>{{ row.program_starting_date }}</td>
													<td>{{ row.onboard_date }}</td>
													<td>{{ row.duration_method }}</td>
													<td>{{ row.country_code }}</td>
													<td>{{ row.telephone_number }}</td>
													<td v-if="previews.view == 'complete'">{{ row.coordinator }}</td>
													<td v-if="previews.view == 'complete'">{{ row.lhcsa_manager }}</td>
													<td v-if="previews.view == 'complete'">{{ row.manager_approving_the_hha_score }}</td>
													<td v-if="previews.view == 'complete'">{{ row.supporting_rn }}</td>
													<td v-if="previews.view == 'complete'">{{ row.employee_number }}</td>
													<td v-if="previews.view == 'complete'">{{ row.ssn }}</td>
													<!-- <td v-if="previews.view == 'complete'">{{ row.birthday }}</td> -->
													<td v-if="previews.view == 'complete'">{{ row.preferred_language }}</td>
													<td v-if="previews.view == 'complete'">{{ row.hha_registry_number }}</td>
													<td v-if="previews.view == 'complete'">{{ row.discipline }}</td>
													<td v-if="previews.view == 'complete'">{{ row.location }}</td>
												</tr>
											</tbody>
										</table>	
									</div>

									<div class="row justify-content-between ">
										<div class="col-12 col-lg-6">
											<span>Showing {{ previews.from }} to {{ previews.to }} of {{ previews.total_rows }}</span>
										</div><!--col-->
										<div class="col-12 col-lg-6">
											<b-pagination align="right" :total-rows="previews.total_rows" v-model="previews.current_page"  @change="setPage" :per-page="parseInt(previews.per_page)">
									    	</b-pagination>
										</div><!--col-->
									</div><!--row-->

								</div>
							</div>

							<!-- alert before import -->
							<b-modal id="alert-import" title="Import" size="lg" @ok="processImport()">
								<p>
									You are about to import all the rows displayed in the preview. This may take a while if the excel is too big. 
								</p>							
							</b-modal>
							<b-modal id="alert-export" title="Import" size="lg" @ok="processImport()">
								<p>
									You are about to export all the rows displayed in the preview as CSV.
								</p>							
							</b-modal>
						</template>
					</template>
				</div><!--col-->
			</div><!--row-->
		</div>
	</div>
</template>

<script>
	export default {
		data : function(){
			return {
				id : this.$route.params.id,
				import_id : this.$route.params.import_id,
				organization : null,
				import_ : null,
				fields : [],
				previews : {
					current_page : 1,
					total_rows : 0,
					per_page  : 0,
					from : 0,
					to : 0,
					filter_status : 'all',
					view : 'simple',
					filter_import_status : 'all',
					data: []
				},

				refreshing : false,
				open_preview:false,
				raw_previews: {
					data:[]
				},
				all_formats: {},
				sample_data:[],
				date_formats: []
			}
		},

		created : function(){
			this.getImport();
			this.getOrganization();
			this.getAvailableFields();
			this.getRawPreview();
			this.getFormats();
		},

		filters : {
			format_object_column : function(column){

				var str = column;
				if(column != null && typeof(column) == 'object'){
						str = column.value;
				}
				
				return str;
			}
		},
		methods : {
			getOrganization : function(){
				var params = {
					id : this.id
				}

				this.$store.dispatch('getOrganization', params).then((res) => {
					this.organization = res.data.data;
				}).catch((error) => {
					console.log(error);
				});
			},

			getImport : function(options){
				var params = {
					id : this.id,
					import_id : this.import_id,
					filters : {
						page_loading : false
					}
				}

				this.refreshing = true;

				this.$store.dispatch('getOrganizationImport', params).then((res) => {
		
					this.import_ = res.data.data;

					if(this.import_.show_preview){
						this.getPreview();
					}

					if(!this.refresh_active && this.import_.should_reload){

						setTimeout(() => {
							this.getImport();
						}, 5000);
					}else{
						this.refreshing = false;
					}

				}).catch((error) => {
					console.log(error);
				})
			},

			getAvailableFields : function(){

				var params = {
					filters : {
						organization_id : this.id
					}
				}
				this.$store.dispatch('getAvailableFieldsImport', params).then((res) => {
					this.fields = res.data.data;
				}).catch((error) => {
					console.log(error);
				})
			},

			saveFields : function(go_to_preview_import){
				var columns = [];

				for(var i in this.import_.columns){
					var nevvon_column = this.import_.columns[i].nevvon_column;

					if(this.import_.columns[i].label != null && typeof(this.import_.columns[i].label) == 'object'){
					
						nevvon_column = this.import_.columns[i].label.value;
					}

					columns.push({
						excel_column : this.import_.columns[i].excel_column,
						nevvon_column : nevvon_column,
						format: this.import_.columns[i].format
					});
				}

				var params = {
					id : this.id,
					import_id : this.import_id,
					columns : columns
				}

				this.$store.dispatch('editOrganizationImportColumnMapping', params).then((res) => {

					if(go_to_preview_import){

						this.$store.dispatch('generateOrganizationImportPreview', params).then((res) => {
							this.import_ = res.data.import;

							this.getPreview();
						}).catch((error) => {
							console.log(error);
						});
					}
				}).catch((error) => {
					console.log(error);
				})
			},

			getPreview : function(){
				var params = {
					id : this.id,
					import_id : this.import_id,
					filters : {
						page : this.previews.current_page,
						per_page : this.previews.per_page,
						page_loading: false
					}
				}

				if(this.previews.active_filter == 'status'){
					params.filters.status =  this.previews.filter_status;
				}else if(this.previews.active_filter == 'import'){
					params.filters.status_import = this.previews.filter_import_status;
				}

				this.$store.dispatch('getOrganizationImportPreview', params).then((res) => {

					this.previews.data = res.data.data;

					this.previews.current_page = res.data.meta.current_page;
					this.previews.total_rows = res.data.meta.total;
					this.previews.per_page = parseInt(res.data.meta.per_page);
					this.previews.from = res.data.meta.from;
					this.previews.to = res.data.meta.to;

					this.refreshing = false;
					this.$forceUpdate()
				}).catch((error) => {
					console.log(error);
				})
			},

			filterPreviewByStatus : function(status){
				this.previews.filter_status = status;

				this.previews.active_filter = 'status';

				this.getImport();
			},

			filterPreviewByImportStatus : function(status){
				this.previews.filter_import_status = status;

				this.previews.active_filter = 'import';

				this.getImport();
			},

			refreshPreview : function(){
				this.getImport();
			},
			setPage : function(page){
				this.previews.current_page = page;

				this.getImport();
			},

			processImport : function(){

				var params = {
					id : this.id,
					import_id : this.import_id
				}

				this.$store.dispatch('processOrganizationImportPreview', params).then((res) => {
					console.log(res);

					this.getImport();
				}).catch((error) => {
					console.log(error);
				})
			},

			//filter methods
			f_format_object_column : function(column){

				var str = column;
				if(column != null && typeof(column) == 'object'){
						str = column.value;
				}
				
				return str;
			},
			exportCSV(){
				// now we have filtered data -> previews
				let csvContent = "data:text/csv;charset=utf-8,";
					csvContent += [
					Object.keys(this.previews.data[0]).join(";"),
				...this.previews.data.map(item => Object.values(item).join(";"))
				]
				.join("\n")
				.replace(/(^\[)|(\]$)/gm, "");

				const data = encodeURI(csvContent);
				const link = document.createElement("a");
				link.setAttribute("href", data);
				link.setAttribute("download", "export.csv");
				link.click();
			},

			getRawPreview: function() {
				var params = {
					id: this.id,
					import_id: this.import_id
				};

				this.$store.dispatch("getOrganizationImportRawPreview", params).then(res => {
					this.raw_previews.data = res.data.data;
					this.sample_data = this.raw_previews.data[0]['raw_data'];
				})
				.catch(error => {
					console.log(error);
				});
			},

			getFormats: function() {
				var params = {
				};

				this.$store.dispatch("getImportFormats", params).then(res => {
					this.all_formats = res.data.data;
					this.filterFormatByDate();
				})
				.catch(error => {
					console.log(error);
				});
					
			},

			filterFormatByDate: function() {
				for(var i in this.all_formats){
					if(this.all_formats[i].type == 'date'){
						this.date_formats.push(this.all_formats[i].excel_format);
					}
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/admin/organization/imports/AdminOrganizationImportsDetailComponent.vue